<template>
    <Breadcrumbs
        main="Liste des fiches & contacts"
        mains="Liste des fiches & contacts"
        title="Publication"
    />
    <div class="container-fluid">
        <div class="row">
            <CardList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue';
const CardList = defineAsyncComponent(
    () => import('@/components/theme/card/CardList.vue'),
);
</script>